import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {ApplicationError} from '../model/application-error';
import {Observable, of, throwError} from 'rxjs';
import {AuthService} from './auth.service';
import {catchError, tap} from 'rxjs/operators';
import {head} from "lodash-es";

@Injectable()
export class HttpService {

  constructor(protected httpClient: HttpClient, protected authService: AuthService) {
  }

  protected getResponse<T>(url): Observable<T> {
    if (this.authService.getIfPlatformBrowser()) {
      if (!this.authService.isLoggedIn()) {
        this.authService.redirectToHome('Not authorized');
        return throwError('Not authorized');
      }
      try {
        return this.httpClient.get<T>(url, this.authService.createHeadersOptions()).pipe(
          catchError(this.handleError(url))
        );
      } catch (e) {
        console.log('unable to make request to url ' + url);
        return of<T>();
      }
    } else {
      return of<T>();
    }
  }

  protected getResponseUnAuthenticatedRequest<T>(url): Observable<any> {
    if (this.authService.getIfPlatformBrowser()) {
      try {
        return this.httpClient.get<T>(url, this.authService.createHeadersOptions()).pipe(
          catchError(this.handleError(url))
        );
      } catch (e) {
        console.log('unable to make request to url ' + url);
        return of<T>();
      }
    } else {
      return of<T>();
    }
  }

  protected sendPostRequest<T>(url, obj, headers?): Observable<T> {
    if (!this.authService.isLoggedIn()) {
      this.authService.redirectToHome('Not authorized');
      return throwError(() => new Error('Not authorized'));
    }
    return this.httpClient.post<T>(url, obj, this.authService.createHeadersOptions(headers)).pipe(
      catchError(this.handleError(url, obj))
    );
  }

  protected sendPutRequest<T>(url, obj): Observable<T> {
    if (!this.authService.isLoggedIn()) {
      this.authService.redirectToHome('Not authorized');
      return throwError(() => new Error('Not authorized'));
    }
    return this.httpClient.put<T>(url, obj, this.authService.createHeadersOptions()).pipe(
      catchError(this.handleError(url, obj))
    );
  }

  protected getPostResponseUnAuthenticatedRequest<T>(url, obj, headers?): Observable<any> {
    return this.httpClient.post<T>(url, obj, this.authService.createHeadersOptions(headers)).pipe(
      tap(data => console.log('posted data')),
      catchError(this.handleError(url, obj))
    );
  }


  protected handleError<T>(operation = 'operation', obj?) {
    return (err: HttpErrorResponse) => {
      console.log(err);

      const errCode: number = err.status;
      let errMsg: string;

      if (errCode === 401) {
        this.authService.logout();
      }

      if(errCode == 500){
        this.authService.error();
      }
      if (errCode === 0) {
        errMsg = 'Currently not able to connect to the server. Please make sure you have proper network connection and reload the page.';
      } else if (errCode === 429) {
        errMsg = "Too Many Requests. Please try after some time."
      } else {
        errMsg = err.error;
      }

      if (errMsg == null) {
        errMsg = "Something went wrong. Please try after some time."
      }
      const appError: ApplicationError = {
        errorCode: errCode,
        message: errMsg,
      };

      return throwError(appError);
    };
  }
}
